const { gql } = require("graphql.macro");
export const queryMemberShipList = gql`
  query queryMemberShipList($itemPath: String = "/sitecore/content/lynkco-global-portal/Global Setting/Membership List", $language: String = "en") {
    obj: item(path: $itemPath, language: $language) {
      list: children {
        ...memberShipList
      }
    }
  }
  fragment memberShipList on MembershipLevelTemplate {
    key: field(name: "key") {
      value
    }
    name: field(name: "name") {
      value
    }
  }
`;
